module.exports = __webpack_public_path__ + "static/media/MaterialIcons-Regular.a37b0c01.ttf";